// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay-new-video{box-shadow:0 2px 9px 0 rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = exports;
